import { render, staticRenderFns } from "./Historiqueemail.vue?vue&type=template&id=4c91b810"
import script from "./Historiqueemail.vue?vue&type=script&lang=js"
export * from "./Historiqueemail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports